import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'

const ROLE_TABS = [
  {
    label: '系统角色',
    theme: 'role',
    step: 'sysRolesList',
    stepLabel: '系统角色列表',
    checkFun: 'role/getSysRoles'
  },
  {
    label: '机构角色',
    theme: 'role',
    step: 'orgAllRolesList',
    stepLabel: '机构角色列表',
    checkFun: 'role/getOrgAllRoles'
  },
  {
    label: '下级角色',
    theme: 'role',
    step: 'orgAllRolesList',
    stepLabel: '下级机构角色列表',
    checkFun: 'role/getOrgAllRoles'
  }
]

const role = {
  pageTabs: (params) => {
    if (params && params.orgName === '甘肃大鹏鸟科技有限公司') {
      return ROLE_TABS
    }
    return ROLE_TABS.filter((item) => item.label !== '系统角色')
  },
  navBar: {
    navTitle: '机构列表',
    queryFun: 'role/getOrgAllRoles'
  },
  sysRoles: {
    name: 'sysRoles',
    theme: '系统角色',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'dialogForm',
      'setRights',
      'navBar',
      'pageTabs'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'role/getSysRoles',
    deleteFun: 'role/deleteSysRole',
    detailPage: [
      {
        buttonName: '新增',
        type: 'dialogForm',
        name: 'sysRoles'
      },
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'sysRoles',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置web权限',
        type: 'other',
        name: 'setRights',
        step: 'setRightsInfo',
        theme: 'role',
        label: '配置web权限信息',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置app权限',
        type: 'other',
        name: 'setRights',
        step: 'setRightsInfo',
        theme: 'role',
        label: '配置app权限信息',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    rowData: (params) => {
      return params.state.role.sysRoles
    },
    columns: [
      { prop: 'roleCode', label: '角色编码', minWidth: '110px' },
      { prop: 'roleName', label: '角色名称', minWidth: '110px' },
      {
        prop: 'isEdit',
        label: '是否允许编辑',
        width: '110px',
        tag: (params) => {
          return params.dictionarys.isFalse
        }
      },
      {
        prop: 'isPreset',
        label: '是否初始化',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.isFalse
        }
      },
      { prop: 'orgType', label: '角色类型', minWidth: '90px' },
      {
        label: '操作',
        buttons: setTableButtons([
          '查看',
          '编辑',
          '删除',
          '配置web权限',
          '配置app权限'
        ]),
        minWidth: '430px',
        overflow: false
      }
    ],
    hasPagination: false,
    sysRoles: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增用户角色'
          : params.pageStatus === 'edit'
          ? '编辑用户角色'
          : ''
      },
      formKey: 'orgUid',
      addFun: 'role/addSysRole',
      editFun: 'role/editSysRole',
      getParentFun: 'role/getSysRoles',
      formParams: {
        orgUid: '',
        uid: '',
        roleCode: '',
        roleName: '',
        isChange: '',
        isInit: '',
        orgType: ''
      },
      formRules: {
        roleCode: [
          {
            required: true,
            message: '请输入英文字符、数字或下划线组成的唯一标识角色',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9a-zA-Z_]{1,}$/,
            message: '请输入英文字符、数字或下划线组成的唯一标识角色',
            trigger: 'blur'
          }
        ],
        roleName: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'input'
          }
        ],
        isChange: [
          {
            required: true,
            message: '请选择是否允许编辑',
            trigger: 'blur'
          }
        ],
        isInit: [
          {
            required: true,
            message: '请选择是否初始化',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'roleCode',
          label: '角色编码',
          type: 'input',
          placeholder: '请输入英文字符、数字或下划线组成的唯一标识角色',
          span: 18
        },
        {
          key: 'roleName',
          label: '角色名称',
          type: 'input',
          span: 18
        },
        {
          key: 'isChange',
          label: '是否可编辑',
          type: 'select',
          placeholder: '请选择是否允许机构管理员编辑',
          options: (params) => {
            return params.dictionarys.isFalse
          },
          checkByValue: true,
          span: 18
        },
        {
          key: 'isInit',
          label: '是否初始化',
          type: 'select',
          placeholder: '请选择是否初始化给机构',
          options: (params) => {
            return params.dictionarys.isFalse
          },
          checkByValue: true,
          span: 18
        },
        {
          key: 'orgType',
          label: '角色类型',
          type: 'select',
          placeholder: '请选择要初始化的对应机构类型',
          options: (params) => {
            return params.dictionarys.orgType
          },
          checkByValue: true,
          span: 18
        }
      ]
    }
  },
  orgAllRoles: {
    name: 'orgAllRoles',
    theme: '机构角色',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'dialogForm',
      'setRights',
      'navBar',
      'pageTabs'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    queryFunFun: 'role/getOrgAllRoles',
    getListFun: 'role/getOrgAllRoles',
    deleteFun: 'role/deleteOrgSysRole',
    detailPage: [
      {
        buttonName: '新增',
        type: 'dialogForm',
        name: 'orgAllRoles'
      },
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'orgAllRoles',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置web权限',
        type: 'other',
        name: 'setRights',
        step: 'setRightsInfo',
        theme: 'role',
        label: '配置web权限信息',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置app权限',
        type: 'other',
        name: 'setRights',
        step: 'setRightsInfo',
        theme: 'role',
        label: '配置app权限信息',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增', '同步预设角色']),
    rowData: (params) => {
      return params.state.role.orgRoles
    },
    columns: [
      { prop: 'roleCode', label: '角色编码', minWidth: '110px' },
      { prop: 'roleName', label: '角色名称', minWidth: '110px' },
      {
        prop: 'isEdit',
        label: '是否允许编辑',
        width: '110px',
        tag: (params) => {
          return params.dictionarys.isFalse
        }
      },
      {
        label: '操作',
        buttons: setTableButtons([
          '查看',
          '编辑',
          '删除',
          '配置web权限',
          '配置app权限'
        ]),
        minWidth: '430px',
        overflow: false
      }
    ],
    hasPagination: false,
    orgAllRoles: {
      title: (params) => {
        return params.pageStatus === 'add'
          ? '新增用户角色'
          : params.pageStatus === 'edit'
          ? '编辑用户角色'
          : ''
      },
      formKey: 'orgUid',
      addFun: 'role/addOrgSysRole',
      editFun: 'role/editOrgSysRole',
      getParentFun: 'role/getOrgAllRoles',
      formParams: {
        orgUid: '',
        uid: '',
        roleCode: '',
        roleName: '',
        isChange: '1',
        orgType: ''
      },
      formRules: {
        roleCode: [
          {
            required: true,
            message: '请输入英文字符、数字或下划线组成的唯一标识角色',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9a-zA-Z_]{1,}$/,
            message: '请输入英文字符、数字或下划线组成的唯一标识角色',
            trigger: 'blur'
          }
        ],
        roleName: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'input'
          }
        ],
        isChange: [
          {
            required: (params) => {
              const admin =
                (params.state && params.state.superAdminName) || 'dpnadmin'
              const user = (params.state && params.state.user) || {}
              return user.userName === admin || user.personName === admin
            },
            message: '请选择是否允许编辑',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'roleCode',
          label: '角色编码',
          type: 'input',
          placeholder: '请输入英文字符、数字或下划线组成的唯一标识角色',
          span: 18
        },
        {
          key: 'roleName',
          label: '角色名称',
          type: 'input',
          span: 18
        },
        {
          key: 'isChange',
          label: '是否可编辑',
          type: 'select',
          placeholder: '请选择是否允许机构管理员编辑',
          options: (params) => {
            return params.dictionarys.isFalse
          },
          checkByValue: true,
          span: 18,
          isShow: (params) => {
            const admin =
              (params.state && params.state.superAdminName) || 'dpnadmin'
            const user = (params.state && params.state.user) || {}
            return user.userName === admin || user.personName === admin
          }
        },
        {
          key: 'orgType',
          label: '角色类型',
          type: 'select',
          placeholder: '请选择要初始化的对应机构类型',
          options: (params) => {
            return params.dictionarys.orgType
          },
          checkByValue: true,
          span: 18,
          isShow: (params) => {
            const admin =
              (params.state && params.state.superAdminName) || 'dpnadmin'
            const user = (params.state && params.state.user) || {}
            return user.userName === admin || user.personName === admin
          }
        }
      ]
    }
  }
}

export default role
